import {styled, OutlinedInput as MuiOutlinedInput} from "@mui/material";

const OutlinedInput = styled(MuiOutlinedInput)(({theme}) => {
  return {
    '&.MuiOutlinedInput-root': {
      '.MuiInputBase-input': {
        // color: 'red',
      },
      '& fieldset': {
        // borderColor: '#dddddd !important',
      },
    },
    '&.Mui-focused': {
      '& .MuiOutlinedInput-notchedOutline': {
        // borderColor: '#dddddd !important',
      },
      '& fieldset': {
        // border: '1px solid #dddddd !important',
      },
    },
    '&.MuiInputBase-root': {
      '&:hover fieldset': {
        // borderColor: '#dddddd !important',
      }
    },

    // backgroundColor: theme.palette.lineCardColour.popUpWhite,
    // color: theme.palette.background.cocor,
    // border: `1px solid ${theme.palette.lineCardColour.firstLine}`,
  }
});

export {OutlinedInput}